import type { BackofficeUserOrganization, CustomerContractDescription } from '@orus.eu/backend'

export function isBrokerClientFromContracts(
  contracts: ReadonlyArray<Pick<CustomerContractDescription, 'isManagedByOrus'>>,
): boolean {
  return contracts.some((contract) => !contract.isManagedByOrus)
}

export function isBrokerClientFromOrganizations(
  organizations: ReadonlyArray<Pick<BackofficeUserOrganization, 'isManagedByOrus'>>,
): boolean {
  return organizations.some((organization) => !organization.isManagedByOrus)
}
